import { Link } from 'react-router-dom';

export default function Cta() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="relative overflow-hidden rounded-2xl">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20comic%20pop%20art%20background%20with%20halftone%20dots%2C%20speech%20bubbles%20and%20dynamic%20comic%20burst%20rays%2C%20warm%20orange%20amber%20and%20gold%20color%20palette%20on%20dark%20background%2C%20vibrant%20energetic%20atmosphere%2C%20stylized%20illustration%2C%20high%20detail&width=1600&height=600&seq=cta-banner&orientation=landscape"
          alt="加入麻瓜漫画网"
          loading="lazy"
          className="h-[300px] md:h-[340px] w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/30"></div>
        <div className="absolute inset-0 halftone opacity-20"></div>
        <div className="relative flex h-full flex-col items-start justify-center px-8 md:px-14 py-10">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50 whitespace-nowrap">
            <i className="ri-magic-line"></i> 现在就出发
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950">
            别让好故事被删减，原版漫画等你开启
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-800">
            收藏你喜欢的作品，第一时间接收更新提醒，随时随地畅快追更。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/comics"
              className="h-11 flex items-center gap-2 rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i> 开始阅读
            </Link>
            <Link
              to="/contact"
              className="h-11 flex items-center gap-2 rounded-full bg-background-100/80 px-6 text-sm font-semibold text-foreground-950 ring-1 ring-background-300/60 hover:bg-background-200 whitespace-nowrap"
            >
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}